<template>
  <v-chip
    label
    class="text-center flex-grow-1"
    :class="{ 'primary--text': !active }"
    :color="active ? 'primary' : 'transparent'"
    :to="chip.route"
    v-bind="$attrs"
    v-on="$listeners"
  >
    {{ chip.text }}
    <v-icon v-if="icon">{{ icon }}</v-icon>
  </v-chip>
</template>

<script>
export default {
  props: {
    chip: {
      type: Object,
      required: true,
    },
    icon: String,
  },
  computed: {
    active() {
      if (!this.$route) return false;
      if (this.chip.items) {
        return this.chip.items.some(item => item.route && item.route.name === this.$route.name);
      }
      return this.chip.route && this.chip.route.name === this.$route.name;
    },
  },
};
</script>
